// 서버 알림(notification_outbox.kind) → 토스트 종류 매핑 — 두 수신 경로의 공용 정본.
//
// 서버 알림은 앱에 두 경로로 들어온다. 둘 다 같은 서버 kind를 받으므로 매핑도 한 벌이어야 한다.
//   ① DB 폴링      — useNotificationOutbox.ts (앱 복귀·60초 주기)
//   ② FCM 포그라운드 — App.tsx (앱을 켜둔 채 푸시가 도착)
// ⚠ 2026-09-02: ②가 'achievement' 하드코딩이라 상폐 청산도 록이 축하 알약으로 떴다.
//    ①만 고치고 ②를 놓친 것 — 매핑을 파일 한 곳에 두어 같은 누락이 반복되지 않게 한다.
//
// 기준: 사용자가 **해낸 것**만 게임 계열(캐릭터), 자동으로 벌어진 일은 시스템 계열.
// ⚠ 서버 kind 정본 = lib/notifications/policy.js. 거기 새 kind가 늘면 여기도 함께 늘릴 것.
import type { ToastKind } from './toast';

export const OUTBOX_TOAST: Record<string, { kind: ToastKind; expr?: string }> = {
  // 사용자가 돌린 복기·토론이 끝났다 = 성취
  review_done: { kind: 'achievement', expr: 'celebrate' },
  debate_done: { kind: 'achievement', expr: 'celebrate' },
  // 자동 복기 3종(2026-09-27) — 종전엔 결과가 나빠도 축하 얼굴이었다. 판정별로 표정을 가른다.
  //   반복은 sad가 아니라 focused — 탓하는 얼굴보다 "다시 보자"는 얼굴이 복기 코치 톤에 맞다.
  review_auto_improved: { kind: 'achievement', expr: 'celebrate' },
  review_auto_repeat: { kind: 'achievement', expr: 'focused' },
  review_auto_new: { kind: 'achievement', expr: 'confident' },
  // 재화가 들어왔다 — 좋은 소식이지만 사용자가 한 일은 아니다
  salary_paid: { kind: 'success' },
  dividend_paid: { kind: 'success' },
  voucher_granted: { kind: 'success' },
  debt_paid: { kind: 'success' },
  // 상태가 바뀌었다는 통지
  free_reset: { kind: 'info' },
  price_alert: { kind: 'info' },
  moderation_report: { kind: 'info' }, // 운영자 계정에만 옴 — 신고 접수 통보 (Apple 1.2)
  macro_resolved: { kind: 'info' },
  split_adjusted: { kind: 'info' },
  // 상폐 청산 = 사용자 잘못은 아니지만 자산이 사라진 사건이라 주의를 끌어야 한다(6초).
  delisting_liquidated: { kind: 'error' },
};

/** 서버 kind → 토스트 종류. 미등록 kind는 info 폴백 —
 *  새 알림 종류가 축하 얼굴로 뜨는 것보다 중립이 안전하다. */
export function toastForOutboxKind(kind: string): { kind: ToastKind; expr?: string } {
  return OUTBOX_TOAST[kind] ?? { kind: 'info' };
}
